module.exports = __webpack_public_path__ + "img/software_box.7ba31099.jpg";